import React from 'react'

import { Col, Row } from '_zari/core'

import * as Sections from './sections'

const PresupuestoNuevoReportePage = () => {
  return (
    <>
      <Row>
        <Col md={4}>
          <Sections.ComparativoSection />
        </Col>
        <Col md={4}>
          <Sections.BaseProductoServicioSection />
        </Col>
        <Col md={4}>
          <Sections.BaseCuentaContableSection />
        </Col>
      </Row>
    </>
  )
}

export default PresupuestoNuevoReportePage
